import styled from 'styled-components';

export const ResetPasswordWrapper = styled.div`
`;
